(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cstm-about-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initAH(section) {
      if (section.dataset.cstmAhInit === 'true') return;
      section.dataset.cstmAhInit = 'true';
      const items = section.querySelectorAll('[data-cstm-reveal]');
      if (!('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }
      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry, i) {
          if (entry.isIntersecting) {
            setTimeout(function () { entry.target.classList.add('is-visible'); }, i * 90);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
      items.forEach(function (el) { observer.observe(el); });
    }
    document.querySelectorAll('.cstm-abouthero').forEach(initAH);
    document.addEventListener('shopify:section:load', function (e) {
      const s = e.target.querySelector('.cstm-abouthero');
      if (s) initAH(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cstm-benefits"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBen(section) {
      if (section.dataset.cstmBenInit === 'true') return;
      section.dataset.cstmBenInit = 'true';

      const items = section.querySelectorAll('[data-cstm-reveal]');
      if (!('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }

      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry, i) {
          if (entry.isIntersecting) {
            setTimeout(function () { entry.target.classList.add('is-visible'); }, i * 90);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

      items.forEach(function (el) { observer.observe(el); });
    }

    document.querySelectorAll('.cstm-ben').forEach(initBen);

    document.addEventListener('shopify:section:load', function (e) {
      const s = e.target.querySelector('.cstm-ben');
      if (s) initBen(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cstm-brand-values"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initVal(section) {
      if (section.dataset.cstmValInit === 'true') return;
      section.dataset.cstmValInit = 'true';
      const items = section.querySelectorAll('[data-cstm-reveal]');
      if (!('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }
      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry, i) {
          if (entry.isIntersecting) {
            setTimeout(function () { entry.target.classList.add('is-visible'); }, i * 90);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
      items.forEach(function (el) { observer.observe(el); });
    }
    document.querySelectorAll('.cstm-values').forEach(initVal);
    document.addEventListener('shopify:section:load', function (e) {
      const s = e.target.querySelector('.cstm-values');
      if (s) initVal(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cstm-clinical"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initClin(section) {
      if (section.dataset.cstmClinInit === 'true') return;
      section.dataset.cstmClinInit = 'true';

      const items = section.querySelectorAll('[data-cstm-reveal]');
      if (!('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }

      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry, i) {
          if (entry.isIntersecting) {
            setTimeout(function () { entry.target.classList.add('is-visible'); }, i * 90);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

      items.forEach(function (el) { observer.observe(el); });
    }

    document.querySelectorAll('.cstm-clin').forEach(initClin);

    document.addEventListener('shopify:section:load', function (e) {
      const s = e.target.querySelector('.cstm-clin');
      if (s) initClin(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cstm-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initContact(section) {
      if (section.dataset.cstmContactInit === 'true') return;
      section.dataset.cstmContactInit = 'true';
      var items = section.querySelectorAll('[data-cstm-reveal]');
      if (!('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry, i) {
          if (entry.isIntersecting) {
            setTimeout(function () { entry.target.classList.add('is-visible'); }, i * 90);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      items.forEach(function (el) { observer.observe(el); });
    }
    document.querySelectorAll('.cstm-contact').forEach(initContact);
    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector('.cstm-contact');
      if (s) initContact(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cstm-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFaq(section) {
      if (section.dataset.cstmFaqInit === 'true') return;
      section.dataset.cstmFaqInit = 'true';

      const items = section.querySelectorAll('.cstm-faq__item');

      items.forEach(function (item) {
        const btn = item.querySelector('.cstm-faq__question');
        const answer = item.querySelector('.cstm-faq__answer');
        if (!btn || !answer) return;

        btn.addEventListener('click', function () {
          const isOpen = btn.getAttribute('aria-expanded') === 'true';

          if (isOpen) {
            answer.style.height = answer.scrollHeight + 'px';
            requestAnimationFrame(function () { answer.style.height = '0px'; });
            btn.setAttribute('aria-expanded', 'false');
          } else {
            answer.style.height = answer.scrollHeight + 'px';
            btn.setAttribute('aria-expanded', 'true');
            answer.addEventListener('transitionend', function handler() {
              answer.style.height = 'auto';
              answer.removeEventListener('transitionend', handler);
            });
          }
        });
      });

      // Recalculate open answers on resize so long text never clips
      let resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          items.forEach(function (item) {
            const btn = item.querySelector('.cstm-faq__question');
            const answer = item.querySelector('.cstm-faq__answer');
            if (btn && answer && btn.getAttribute('aria-expanded') === 'true') {
              answer.style.height = 'auto';
            }
          });
        }, 150);
      });
    }

    document.querySelectorAll('.cstm-faq').forEach(initFaq);

    document.addEventListener('shopify:section:load', function (e) {
      const s = e.target.querySelector('.cstm-faq');
      if (s) initFaq(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cstm-featured-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFP(section) {
      if (section.dataset.cstmFpInit === 'true') return;
      section.dataset.cstmFpInit = 'true';

      const items = section.querySelectorAll('[data-cstm-reveal]');
      if (!('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }

      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry, i) {
          if (entry.isIntersecting) {
            setTimeout(function () { entry.target.classList.add('is-visible'); }, i * 90);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

      items.forEach(function (el) { observer.observe(el); });
    }

    document.querySelectorAll('.cstm-fp').forEach(initFP);

    document.addEventListener('shopify:section:load', function (e) {
      const s = e.target.querySelector('.cstm-fp');
      if (s) initFP(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cstm-final-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCta(section) {
      if (section.dataset.cstmCtaInit === 'true') return;
      section.dataset.cstmCtaInit = 'true';
      var items = section.querySelectorAll('[data-cstm-reveal]');
      if (!('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry, i) {
          if (entry.isIntersecting) {
            setTimeout(function () { entry.target.classList.add('is-visible'); }, i * 90);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
      items.forEach(function (el) { observer.observe(el); });
    }
    document.querySelectorAll('.cstm-cta').forEach(initCta);
    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector('.cstm-cta');
      if (s) initCta(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cstm-guide-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGC(section) {
      if (section.dataset.cstmGcInit === 'true') return;
      section.dataset.cstmGcInit = 'true';
      var items = section.querySelectorAll('[data-cstm-reveal]');
      if (!('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry, i) {
          if (entry.isIntersecting) {
            setTimeout(function () { entry.target.classList.add('is-visible'); }, i * 90);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
      items.forEach(function (el) { observer.observe(el); });
    }
    document.querySelectorAll('.cstm-gc').forEach(initGC);
    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector('.cstm-gc');
      if (s) initGC(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cstm-hero-parallax"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHero(section) {
      if (section.dataset.cstmHeroInit === 'true') return;
      section.dataset.cstmHeroInit = 'true';

      var bg = section.querySelector('[data-cstm-parallax]');
      if (!bg) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var speed = parseFloat(section.getAttribute('data-parallax-speed'));
      if (isNaN(speed)) speed = 5;
      var factor = (speed / 10) * 0.5;

      var visible = false;
      var rafId = null;

      function render() {
        var rect = section.getBoundingClientRect();
        var offset = rect.top * -factor;
        bg.style.transform = 'translate3d(0,' + offset + 'px,0)';
        if (visible) rafId = requestAnimationFrame(render);
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          visible = entry.isIntersecting;
          if (visible && rafId === null) {
            rafId = requestAnimationFrame(render);
          } else if (!visible && rafId !== null) {
            cancelAnimationFrame(rafId);
            rafId = null;
          }
        });
      }, { threshold: 0 });

      io.observe(section);
    }

    document.querySelectorAll('[data-cstm-hero]').forEach(initHero);

    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector('[data-cstm-hero]');
      if (s) initHero(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cstm-how-to-use"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRitual(section) {
      if (section.dataset.cstmRitualInit === 'true') return;
      section.dataset.cstmRitualInit = 'true';

      const items = section.querySelectorAll('[data-cstm-reveal]');
      if (!('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }

      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry, i) {
          if (entry.isIntersecting) {
            setTimeout(function () { entry.target.classList.add('is-visible'); }, i * 90);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

      items.forEach(function (el) { observer.observe(el); });
    }

    document.querySelectorAll('.cstm-ritual').forEach(initRitual);

    document.addEventListener('shopify:section:load', function (e) {
      const s = e.target.querySelector('.cstm-ritual');
      if (s) initRitual(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cstm-ingredients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initIngr(section) {
      if (section.dataset.cstmIngrInit === 'true') return;
      section.dataset.cstmIngrInit = 'true';

      const items = section.querySelectorAll('[data-cstm-reveal]');
      if (!('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }

      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry, i) {
          if (entry.isIntersecting) {
            setTimeout(function () { entry.target.classList.add('is-visible'); }, i * 90);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

      items.forEach(function (el) { observer.observe(el); });
    }

    document.querySelectorAll('.cstm-ingr').forEach(initIngr);

    document.addEventListener('shopify:section:load', function (e) {
      const s = e.target.querySelector('.cstm-ingr');
      if (s) initIngr(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cstm-innovation-expanded"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initInnov2(section) {
      if (section.dataset.cstmInnov2Init === 'true') return;
      section.dataset.cstmInnov2Init = 'true';
      const items = section.querySelectorAll('[data-cstm-reveal]');
      if (!('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }
      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry, i) {
          if (entry.isIntersecting) {
            setTimeout(function () { entry.target.classList.add('is-visible'); }, i * 90);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
      items.forEach(function (el) { observer.observe(el); });
    }
    document.querySelectorAll('.cstm-innov2').forEach(initInnov2);
    document.addEventListener('shopify:section:load', function (e) {
      const s = e.target.querySelector('.cstm-innov2');
      if (s) initInnov2(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cstm-innovation"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initInnov(section) {
      if (section.dataset.cstmInnovInit === 'true') return;
      section.dataset.cstmInnovInit = 'true';

      const items = section.querySelectorAll('[data-cstm-reveal]');
      if (!('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }

      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry, i) {
          if (entry.isIntersecting) {
            setTimeout(function () { entry.target.classList.add('is-visible'); }, i * 90);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

      items.forEach(function (el) { observer.observe(el); });
    }

    document.querySelectorAll('.cstm-innov').forEach(initInnov);

    document.addEventListener('shopify:section:load', function (e) {
      const s = e.target.querySelector('.cstm-innov');
      if (s) initInnov(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cstm-our-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initStory(section) {
      if (section.dataset.cstmStoryInit === 'true') return;
      section.dataset.cstmStoryInit = 'true';
      const items = section.querySelectorAll('[data-cstm-reveal]');
      if (!('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }
      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry, i) {
          if (entry.isIntersecting) {
            setTimeout(function () { entry.target.classList.add('is-visible'); }, i * 90);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
      items.forEach(function (el) { observer.observe(el); });
    }
    document.querySelectorAll('.cstm-story').forEach(initStory);
    document.addEventListener('shopify:section:load', function (e) {
      const s = e.target.querySelector('.cstm-story');
      if (s) initStory(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cstm-page-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPH(section) {
      if (section.dataset.cstmPhInit === 'true') return;
      section.dataset.cstmPhInit = 'true';

      var bg = section.querySelector('[data-cstm-ph-parallax]');
      if (!bg) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var visible = false;
      var rafId = null;

      function render() {
        var rect = section.getBoundingClientRect();
        var offset = rect.top * -0.25;
        bg.style.transform = 'translate3d(0,' + offset + 'px,0)';
        if (visible) rafId = requestAnimationFrame(render);
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          visible = entry.isIntersecting;
          if (visible && rafId === null) {
            rafId = requestAnimationFrame(render);
          } else if (!visible && rafId !== null) {
            cancelAnimationFrame(rafId);
            rafId = null;
          }
        });
      }, { threshold: 0 });

      io.observe(section);
    }

    document.querySelectorAll('[data-cstm-ph]').forEach(initPH);

    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector('[data-cstm-ph]');
      if (s) initPH(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cstm-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTest(section) {
      if (section.dataset.cstmTestInit === 'true') return;
      section.dataset.cstmTestInit = 'true';

      const items = section.querySelectorAll('[data-cstm-reveal]');
      if (!('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }

      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry, i) {
          if (entry.isIntersecting) {
            setTimeout(function () { entry.target.classList.add('is-visible'); }, i * 90);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

      items.forEach(function (el) { observer.observe(el); });
    }

    document.querySelectorAll('.cstm-test').forEach(initTest);

    document.addEventListener('shopify:section:load', function (e) {
      const s = e.target.querySelector('.cstm-test');
      if (s) initTest(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cstm-why-split"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initWhy(section) {
      if (section.dataset.cstmWhyInit === 'true') return;
      section.dataset.cstmWhyInit = 'true';
      var items = section.querySelectorAll('[data-cstm-reveal]');
      if (!('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry, i) {
          if (entry.isIntersecting) {
            setTimeout(function () { entry.target.classList.add('is-visible'); }, i * 80);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      items.forEach(function (el) { observer.observe(el); });
    }
    document.querySelectorAll('.cstm-why').forEach(initWhy);
    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector('.cstm-why');
      if (s) initWhy(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
